import { Image, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import Millimetre from "../../Math/Units/Metric/Millimetre";
import { DataRow } from "../DataRow";
import druckStahlImageEN from "../../../images/20231009_Druckpfahl Stahl_EN.png";
import druckStahlImageDE from "../../../images/20231009_Druckpfahl Stahl_DE.png";
import druckStahlImageES from "../../../images/20231009_Druckpfahl Stahl_ES.png";
import { styles, tableStyles } from "../SmartTitanProjektPDF";

export function GermanyPfahlkopfDruckStahl({ data }) {
  const { t, i18n } = useTranslation("translation");
  const druckStahlImage =
    i18n.language === "de-DE"
      ? druckStahlImageDE
      : i18n.language === "es-ES"
        ? druckStahlImageES
        : druckStahlImageEN;
  let itemIndex = 1;
  return (
    <View wrap={true}>
      <View wrap={false}>
        {/* Mindestabmessungen und Position des Übergangsrohrs */}
        <Text style={styles.sectionSubText}>{t("aeussre.minDimensionPositionTransitionPipe")}</Text>
        <View style={tableStyles.tableContainer} wrap={false}>
          {/* Außendurchmesser */}
          <DataRow
            item={{
              title: t("aeussre.minDiameterTransitionPipe"),
              value: data.Germany.PileHeadConstruction.DruckStahl.außendurchmesser,

              // D_{min}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}D_{min}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}D_{min}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}D_{min}",
                height: 7,
                width: 18,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
              // D \geq D_a+2\cdot c_{req}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}D&space;\geq&space;D_a&plus;2\cdot&space;c_{req}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}D&space;\\geq&space;D_a&plus;2\\cdot&space;c_{req}
              formulaImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}D&space;\\geq&space;D_a&plus;2\\cdot&space;c_{req}",
                height: 9,
                width: 64,
              },
            }}
          />

          {/* Wandstärke */}
          <DataRow
            item={{
              title: t("aeussre.minWallThicknessTransitionPipe"),
              value: data.Germany.PileHeadConstruction.DruckStahl.wandstaerke,

              // t_{min}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}t_{min}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}t_{min}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}t_{min}",
                height: 7,
                width: 14,
              },
              valueScale: 1,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
            }}
          />

          {/* Einbindelänge im Fundament */}
          <DataRow
            item={{
              title: t("aeussre.embedmentLengthFoundation"),
              value: data.Germany.PileHeadConstruction.DruckStahl.einbindelaengeFundament,

              // K_{min}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}K_{min}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}K_{min}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}K_{min}",
                height: 7,
                width: 18,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
            }}
          />

          {/* Einbindelänge im Baugrund */}
          <DataRow
            item={{
              title: t("aeussre.embedmentLengthBuildingGround"),
              value: data.Germany.PileHeadConstruction.DruckStahl.einbindelaengeBaugrund,

              // L_{b, min}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}L_{b,&space;min}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{b,&space;min}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{b,&space;min}",
                height: 9,
                width: 22,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
            }}
          />

          {/* Gesamtlänge */}
          <DataRow
            item={{
              title: t("aeussre.totalLengthTransitionPipe"),
              value: data.Germany.PileHeadConstruction.DruckStahl.gesamtlaenge,

              // L_{min}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}L_{min}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{min}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{min}",
                height: 7,
                width: 16,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
              // L_{min}\geq K_{min}+L_{b, min}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}L_{min}\geq&space;K_{min}&plus;L_{b,&space;min}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{min}\\geq&space;K_{min}&plus;L_{b,&space;min}
              formulaImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L_{min}\\geq&space;K_{min}&plus;L_{b,&space;min}",
                height: 9,
                width: 80,
              },
            }}
          />
        </View>
      </View>
      <View wrap={false}>
        {/* Mindestabmessungen und Position der Kopfplatte */}
        <Text style={styles.sectionSubText}>{t("aeussre.DimensionsPositionHeadPlate")}</Text>
        <View style={tableStyles.tableContainer} wrap={false}>
          {/* Kantenlänge */}
          <DataRow
            item={{
              title: t("aeussre.lengthWasherPlate"),
              value: data.Germany.PileHeadConstruction.DruckStahl.kantenlaenge,
              // U
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}U
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}U
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}U",
                height: 6,
                width: 6,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
            }}
          />

          {/* Plattendicke */}
          <DataRow
            item={{
              title: t("aeussre.thicknessWasherPlate"),
              value: data.Germany.PileHeadConstruction.DruckStahl.plattendicke,
              // V
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}V
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}V
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}V",
                height: 6,
                width: 6,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
            }}
          />

          {/* Abstand zum Übergangsrohr */}
          <DataRow
            item={{
              title: t("aeussre.distanceHeadPlateTransitionTube"),
              value: data.Germany.PileHeadConstruction.DruckStahl.abstandUebergangsrohr,
              // A_{min}
              // https://latex.codecogs.com/png.image?\inline&space;\dpi{110}\bg{white}A_{min}
              // https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}A_{min}
              bezImage: {
                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}A_{min}",
                height: 7,
                width: 18,
              },
              valueScale: 0,
              itemIndex: itemIndex++,
              valueUnit: <Millimetre />,
            }}
          />
          {/* <InvoiceTableBlankSpace rowsCount={25 - itemIndex} /> */}
        </View>
      </View>
      <View style={{ alignItems: "center", marginTop: 20 }} wrap={true}>
        <Image style={{ width: "200px" }} src={druckStahlImage} />
      </View>
    </View>
  );
}
